import React, { useState, useEffect } from 'react';
import { PricingOverview } from 'src/components/Pricing/PricingOverview';
import { Prices } from 'src/components/Pricing/Prices';
import { SetupCharges } from 'src/components/Pricing/SetupCharges';
import { Extras } from 'src/components/Pricing/Extras';
import { GetAPrice } from 'src/components/Pricing/GetAPrice';
import QuickQuoteModal from 'src/elements/QuickQuote/QuickQuoteModal';
import { useHeadTags, escapeAttr } from 'src/core/engine/head';
import { useIsIrishUser } from 'src/util/cookies';
import { Wrapper } from 'src/components/Layout';

import classes from './Pricing.scss';

export const Pricing = () => {
    const [openSidebar, setOpenSidebar] = useState<boolean>(false);
    const isIrishUser = useIsIrishUser();
    const { setHead } = useHeadTags();

    useEffect(() => {
        setHead({
            title: '<title>Cheap Workwear &amp; Embroidered Clothing Printing</title>',
            meta: `<meta name="description" content="${escapeAttr("Affordable customised work wear. Fair prices & low setup charges, hand-crafted by our UK based team. Superb customer service - 600K customers can't be wrong!")}" />`,
        });
    }, [setHead]);

    return (
        <Wrapper bg="white" variant="widget-wrapper-no-padding">
            <div className={classes.container}>
                <PricingOverview />
                <Prices isIrishUser={isIrishUser} />
                <SetupCharges isIrishUser={isIrishUser} />
                {/*<Extras /> Commented out temporarily*/}
                <GetAPrice onClick={() => setOpenSidebar(true)} />
                <QuickQuoteModal sku="PricingQuickQuote" close={() => setOpenSidebar(false)} quoteOpen={openSidebar} />
            </div>
        </Wrapper>
    );
};
